import AppRouter from "./lib/routes/AppRouter";
import "./lib/styles/global.scss";
import { AuthProvider } from "./pages/Auth/hooks/useAuth";
import { SnackbarProvider } from "notistack";
import { ErrorSnack } from "./lib/components/Snackbar";
import { SnackbarUtilsConfigurator } from "./lib/components/Snackbar/utils";
import StyledMaterialDesignContent from "./lib/components/Snackbar/styledMaterialDesignContent";

function App() {
  return (
    <SnackbarProvider
      maxSnack={5} // Allow 5 notifications to stack
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        enphaseError: ErrorSnack, // Register your custom variant name
      }}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={5000}
    >
      <SnackbarUtilsConfigurator />
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </SnackbarProvider>
  );
}

export default App;
